<!-- Hidden file input for uploads -->
<input
    #fileInput
    (change)="onFileChange($event)"
    [accept]="acceptedTypes"
    aria-hidden="true"
    style="display: none"
    type="file"
/>

<!-- Loading spinner, announced to screen readers -->
@if (mediaIsLoading) {
    <mat-spinner
        class="app-media-upload__spinner"
        aria-label="Loading"
        role="status"
        aria-live="polite"
    ></mat-spinner>
}

<!-- If a media is present -->
@if (!!media) {
    <div
        class="app-media-upload__overlay"
        role="region"
        aria-live="polite"
        aria-label="Media preview"
    >
        <!-- Projected media content -->
        <ng-content select="[data-media]"></ng-content>

        <!-- If not in delete mode -->
        @if (!isDeleteActive) {
            <!-- Success info after upload -->
            <ng-content
                select="[data-mediaInfosUploadSuccess]"
                class="app-media-upload__infos-success"
            ></ng-content>
            <div class="app-media-upload__actions">
                <!-- Button to activate delete mode -->
                <button
                    class="app-media-upload__onActivateDeleteClick"
                    (click)="onActivateDeleteClick($event)"
                    *ngIf="isDeleteActive === false"
                    type="button"
                    aria-label="Delete media"
                >
                    <mat-icon svgIcon="delete"></mat-icon>
                </button>
            </div>
        } @else {
            <!-- Delete confirmation and actions -->
            <ng-content select="[data-mediaDeleteWarningInfos]"></ng-content>
            <div class="app-media-upload__actions">
                <button
                    class="app-media-upload__onDeleteClick"
                    (click)="onDeleteClick($event)"
                    type="button"
                    aria-label="Confirm delete"
                >
                    {{ 'activity_edition.media_delete' | translate }}
                </button>
                <button
                    class="app-media-upload__onCancelDelete"
                    (click)="onCancelDelete($event)"
                    type="button"
                    aria-label="Cancel delete"
                >
                    {{ 'activity_edition.avoid_media_delete' | translate }}
                </button>
            </div>
        }
    </div>
} @else {
    <!-- If no media is present -->
    <div
        class="app-media-upload__overlay"
        role="region"
        aria-live="polite"
        aria-label="No media"
    >
        <!-- Projected info content -->
        <ng-content select="[data-mediaInfos]"></ng-content>

        <!-- Error messages, announced assertively -->
        @if (errors.length > 0) {
            <ul
                class="app-media-upload__errors"
                aria-live="assertive"
                role="alert"
                aria-label="Upload errors"
            >
                <li
                    *ngFor="let error of errors"
                    class="app-media-upload__error"
                    role="alert"
                >
                    <mat-icon svgIcon="error"></mat-icon>
                    <span>{{ error | translate }}</span>
                </li>
            </ul>
        }

        <div class="app-media-upload__actions">
            <!-- Button to trigger file input -->
            <button
                class="app-media-upload__fileInput"
                *ngIf="!media"
                (click)="fileInput.click()"
                type="button"
                aria-label="Upload media"
            >
                <mat-icon svgIcon="upload"></mat-icon>
                <span>{{ 'activity_edition.media_upload' | translate }}</span>
            </button>
        </div>
    </div>
}